import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
} from '@angular/core';
import { Router } from '@angular/router';
import { PaymentDashboardAnalyticsService } from '@payments/pages/payment-dashboard/tracking/analytics/payment-dashboard-analytics.service';
import { PaymentDashboardRowsComponent } from '../payment-dashboard-rows.component';
import { PaymentsModalService } from '@payments/services/payments-modal.service';

@Component({
  selector: 'app-account-activity-row-touch',
  templateUrl: './account-activity-row-touch.component.html',
  styleUrls: [
    '../payment-dashboard-rows.component.scss',
    './account-activity-row-touch.component.scss',
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountActivityRowTouchComponent extends PaymentDashboardRowsComponent {
  @Input() isDsmDashboardOn: boolean;

  constructor(
    readonly router: Router,
    protected paymentDashboardAnalytics: PaymentDashboardAnalyticsService,
    protected paymentsModalService: PaymentsModalService,
    protected changeDetectorRef: ChangeDetectorRef,
  ) {
    super(
      router,
      paymentDashboardAnalytics,
      paymentsModalService,
      changeDetectorRef,
    );
  }
}
